import { CatalogState } from ".";

const getters = {
    selectedFilters: (state:CatalogState) => state.selectedFilters,
    selectedRange: (state:CatalogState) => state.selectedRange,
};

export default getters;